'use client';

import { useEffect } from 'react';
import { captureLandingAttribution } from '@/utils/landing-attribution';

export default function AttributionCapture() {
  useEffect(() => {
    captureLandingAttribution();
  }, []);

  return null;
}
